import Header from "./Header/Header";
import styles from "./MainLayout.module.scss";
import SideBar from "../../navigation/components/SideBar/SideBar";
import BGColor from "../../assets/bg-main-layout.svg";

export interface MainLayoutProps {
  children: React.ReactNode;
  title?: string;
  titleRender?: React.ReactNode;
}
/**
 * Main layout
 *
 * Use when the user is connected
 *
 * @param param0
 * @returns
 */
export default function MainLayout({
  children,
  title,
  titleRender,

}: MainLayoutProps) {
  return (
    <div className={styles["page"]}>   
    <img className={styles["background"]} src={BGColor} alt="background" />
      <div className={styles["page__header-global"]}>
  
        <Header />

      </div>

      <div
        className={[
          styles["page__global-container"],
          styles["global-container"],
        ].join(" ")}
      >
        <div className={styles["global-container__left"]}>
          <div className={styles["global-container__left__content"]}>
          <SideBar/>
          </div>
        </div>
        <div
          className={[
            styles["global-container__right"],
            styles["content"],
          ].join(" ")}
        >
          <div
            className={[
              styles["header-content"],
              styles["content__header-content"],
            ].join(" ")}
          >
            {titleRender && titleRender}
            {title && (
              <h1 className={styles["header-content__title"]}>{title}</h1>
            )}
          </div>
          <div className={styles["content__body"]}>{children}</div>
        </div>
      </div>
    </div>
  );
}
